import React from "react";

const AgentContent = (props) => {
  const { image, title, profits, sales, transaction } = props;
  return (
    <>
      <div className="grid grid-cols-1 min-w-max md:grid-cols-3 gap-1">
        <div className="flex items-center">
          <img className="w-14 h-14 rounded-full" src={image} alt="imageproduct" />
        </div>
        <div className="col-span-2">
          <div className="flex items-center">
            <div>
              <div className="text-light-blue text-xs font-bold">{title}</div>
              <div className="grid grid-cols-2 text-s">
                <div className="text-light-gray text-s ">Profits</div>
                <div className="font-bold text-s text-light-black text-center">{profits}</div>
              </div>
              <div className="grid grid-cols-2 text-s">
                <div className="text-light-gray">Sales</div>
                <div className="font-bold text-light-black text-center">{sales}</div>
              </div>
              <div className="grid grid-cols-2 text-s font-bold">
                <div className="text-light-gray">Transaction</div>
                <div className="text-light-black text-center">{transaction}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgentContent;
